import { Block } from "@/components/Block";
import { CopyIcon } from "@/components/CopyIcon";
import { Countdown } from "@/components/Countdown";
import { MakeDialog } from "@/components/Dialog";
import {
  Header,
  HeaderActionBack,
  HeaderActionCustomerService,
} from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Layout } from "@/components/Layout";
import { PaymentIcons } from "@/components/PaymentIcons";
import { PaymentInfo } from "@/components/PaymentInfo";
import { ShowResult, usePopup } from "@/components/Popup";
import { TradeBoard } from "@/components/TradeBoard";
import { TradeSteps, TransactionStatusOnStep } from "@/components/TradeSteps";
import { useCustomerPopup } from "@/components/CustomerPopup";
import { OrderStatus, Payments } from "@/constants";
import { cn } from "@/libs";
import tools, { toMoney } from "@/utils/tool";
import { useCountDown, useUnmount } from "ahooks";
import { Avatar, Button, PullToRefresh } from "antd-mobile";
import { BoardProps, PreviewScreenShot } from "../buy_trading";
import { dialogConfirmCancelTradingSell } from "./dialogs";
import { dialogConfirmDidNotRecived, dialogConfirmTrading } from "./dialogs";
import styles from "./index.module.scss";
import { useSetup } from "./logic";

let handler: ShowResult;

export const PageSellTrading = () => {
  const logic = useSetup();
  const [showConfirmCompleteTradingDialog] = usePopup();
  const [customerPopup] = useCustomerPopup();

  useUnmount(() => {
    handler?.close();
  });

  if (tools.isUndefined(logic.state.order)) return <></>;

  /** 展示倒计时组件 */
  const showCountdown =
    logic.state.status === OrderStatus.BUYER_REQUEST ||
    logic.state.status === OrderStatus.WAITING_FOR_TRANSFER ||
    logic.state.status === OrderStatus.TRANSFERRED;

  const isCountdownEnd = logic.state.countdown <= 0;
  /** 展示付款信息 */
  const showPaymentInfomation =
    (logic.state.status === OrderStatus.TRANSFERRED && !isCountdownEnd) ||
    logic.state.status === OrderStatus.DISPUTING;
    
  const isProfession = logic.state.order.isProfession;//是否超级商家挂单  1超级商家 0普通商家
  const isSystemBuyer = logic.state.order.buyerType === "System";
  const showSystemBuyer =
    isSystemBuyer &&
    TransactionStatusOnStep[logic.state.status as OrderStatus] > 2;

  const showBuyerIndicator = logic.state.status === OrderStatus.BUYER_REQUEST;

  /** 展示支付截图或截图上传组件 */
  const showPaidScreenShot =
    logic.state.status === OrderStatus.TRANSFERRED ||
    (logic.state.status === OrderStatus.SELLER_DID_NOT_RECEIVE &&
      !isCountdownEnd) ||
    logic.state.status === OrderStatus.DISPUTING;

  const showTradingNotice =
    logic.state.status === OrderStatus.WAITING_FOR_TRANSFER ||
    logic.state.status === OrderStatus.TRANSFERRED;

  /** 争议订单 */
  const isDisputing = logic.state.status === OrderStatus.DISPUTING;

  const dialogConfirmCompleteTrading = () => {
    handler = showConfirmCompleteTradingDialog({
      className: styles.applyArbitrateDialog,
      content: (
        <ConfirmCompleteTradingDialogContent
          onConfirm={async () => {
            await logic.confirmCompleteTrading();
            handler?.close();
          }}
          onCancel={() => {
            handler?.close();
          }}
        />
      ),
    });
  };

  return (
    <Layout
      ref={logic.scollableRef}
      scrollable
      backgroundImage={false}
      header={
        <Header
          title="我的卖单"
          leftActions={<HeaderActionBack />}
          rightActions={<HeaderActionCustomerService />}
        />
      }
    >
      <PullToRefresh onRefresh={async () => logic.refreshFun()}>
        <Board
          state={logic.state.status as OrderStatus}
          orderDurations={logic.orderDurations}
          isProfession={isProfession}
        >
          {showCountdown && (
            <div className={styles.boardContentCountdown}>
              订单倒计时：
              <Countdown
                duration={logic.state.countdown}
                onFinish={() => logic.dispatch({ type: "finish-countdown" })}
              />
            </div>
          )}

          <div className={styles.boardContentOrderNumber}>
            订单编号：{logic.state.order.pendingOrderNo}
            <CopyIcon text={logic.state.order.pendingOrderNo} />
          </div>
        </Board>

        <Block
          topline
          title={
            <div className={styles.blockTitle}>
              购买数量
              <div className={styles.vcoinNumber}>
                <span>{toMoney(logic.state.order.amount)}</span>
                <Icon
                  className={styles.vcoin}
                  name="vcoin"
                  size={["28px", "14px"]}
                />
              </div>
            </div>
          }
        />

        <Block
          nextby
          title={
            <div className={styles.blockTitle}>
              收款方式
              <div className={styles.payments}>
                <PaymentIcons
                  payments={logic.state.order.paymentType}
                  size="24px"
                />
              </div>
            </div>
          }
        />

        <Block topline title="交易进度">
          <TradeSteps
            status={logic.state.status as OrderStatus}
            createTime={logic.state.order.createTime}
          />
        </Block>

        {/* 超级商家隐藏 其他买家付款信息  只展示备注 */}
        {!showSystemBuyer && (
            <Block topline title="买家付款信息">
              <PaymentInfo
                payment={logic.state.order.paymentType as Payments}
                show={showPaymentInfomation}
                info={logic.state.buyerPayment}
                order={logic.state.order}
                isProfession={isProfession}
              />
            </Block>
        )}

        {!showSystemBuyer && showBuyerIndicator && (
          <Block title="买方信用资讯" topline>
            <div className={styles.lineOfSellerInfo}>
              <div className={styles.itemOfSellerInfo}>
                <div className={styles.keyOfSellerInfo}>
                  {logic.state.buyerOrderIndicator!.range}日成单数
                </div>
                <div className={styles.valueOfSellerInfo}>
                  {logic.state.buyerOrderIndicator!.totalSuccessfulOrder}
                </div>
              </div>
              <div className={styles.itemOfSellerInfo}>
                <div className={styles.keyOfSellerInfo}>
                  {logic.state.buyerOrderIndicator!.range}日成单率{" "}
                </div>
                <div className={styles.valueOfSellerInfo}>
                  {logic.state.buyerOrderIndicator!.totalSuccessRate}%
                </div>
              </div>
            </div>

            <div className={styles.lineOfSellerInfo}>
              <div className={styles.itemOfSellerInfo}>
                <div className={styles.keyOfSellerInfo}>
                  {logic.state.buyerOrderIndicator!.range}日平均放币时间{" "}
                </div>
                <div className={styles.valueOfSellerInfo}>
                  {"<"}
                  {logic.state.buyerOrderIndicator!.sellerAvgTime}分钟
                </div>
              </div>
              <div className={styles.itemOfSellerInfo}>
                <div className={styles.keyOfSellerInfo}>
                  {logic.state.buyerOrderIndicator!.range}日平均付款时间{" "}
                </div>
                <div className={styles.valueOfSellerInfo}>
                  {"<"}
                  {logic.state.buyerOrderIndicator!.buyerAvgTime}分钟
                </div>
              </div>
            </div>

            <div className={styles.lineOfSellerInfo}>
              <div className={styles.itemOfSellerInfo}>
                <div className={styles.keyOfSellerInfo}>买单</div>
                <div className={styles.valueOfSellerInfo}>
                  {" "}
                  {logic.state.buyerOrderIndicator!.buyerOrder}笔
                </div>
              </div>
              <div className={styles.itemOfSellerInfo}>
                <div className={styles.keyOfSellerInfo}>卖单 </div>
                <div className={styles.valueOfSellerInfo}>
                  {logic.state.buyerOrderIndicator!.sellerOrder}笔
                </div>
              </div>
            </div>
          </Block>
        )}

        {showSystemBuyer && <GuaranteeBuyer />}

        {!showBuyerIndicator && (
          <Block topline title="卖家收款信息">
            <PaymentInfo
              payment={logic.state.order.paymentType as Payments}
              show={showPaymentInfomation}
              info={logic.state.sellerPayment}
            />
          </Block>
        )}

        {showSystemBuyer && <Risk />}

        {showPaidScreenShot && (
          <PreviewScreenShot
            src={logic.getSourcePath(logic.state.order.voucher)}
          />
        )}

        {showTradingNotice && <TradingNotice isProfession={isProfession} />}

        <div className={styles.actions}>
          {showBuyerIndicator && (
            <div className={styles.TransferBtn}>
              {
                !logic.isBottom ? (
                  <p className={styles.downSlide}>向下滑动<Icon className={styles.iconArrow} name={"user-arrow-right"} size={"15px"} /></p>
                ):null
              }
              <Button
                className={styles.actionNegative}
                onClick={async () => {
                  const data = await logic.checkCancelable();
                  if (data) {
                    dialogConfirmCancelTradingSell(
                      data,
                      logic.confirmCancelTrading
                    );
                  }
                }}
              >
                取消交易
              </Button>
              <Button
                className={styles.actionPositive}
                onClick={() => dialogConfirmTrading(logic.confirmTrading)}
              >
                开始交易
              </Button>
            </div>
          )}
          {showTradingNotice && (
            <div className={styles.TransferBtn}>
              {
                !logic.isBottom ? (
                  <p className={styles.downSlide}>向下滑动<Icon className={styles.iconArrow} name={"user-arrow-right"} size={"15px"} /></p>
                ):null
              }
              <Button
                disabled={logic.state.status !== OrderStatus.TRANSFERRED}
                className={styles.actionNegative}
                onClick={() =>
                  dialogConfirmDidNotRecived(logic.confirmHasNotRecived)
                }
              >
                未收到转账
              </Button>
              {/* 确认转账并且是非超级商家 禁用 */}
              <Button
                disabled={logic.state.status !== OrderStatus.TRANSFERRED && !isProfession}
                className={styles.actionPositive}
                onClick={() => dialogConfirmCompleteTrading()}
              >
                确认转币
              </Button>
            </div>
          )}

          {isDisputing && (
             <div className={styles.floatBtn}>
              <Button
                className={styles.actionNegative}
                onClick={() => {
                  // TODO: 客服线
                  customerPopup();
                }}
              >
                联系客服
              </Button>
            </div>
          )}
        </div>
      </PullToRefresh>
    </Layout>
  );
};

/**
 * 订单的状态面板
 * @param param0
 * @returns
 */
const Board = ({
  children,
  state,
  orderDurations,
  isProfession,
}: BoardProps<OrderStatus>) => {
  let text = null;

  switch (state) {
    case OrderStatus.BUYER_REQUEST:
      text = (
        <div>
          <div className={styles.boardBgTitle}>请等待卖家确认</div>
          <div className={styles.boardBgDesc}>
            卖家
            <span className={styles.boardBgDescHighlight}>
              {orderDurations.waitingSellerConfirmDelayTime}
            </span>
            内未确认订单
            <br />
            系统默认卖家取消交易
          </div>
        </div>
      );
      break;
    case OrderStatus.SELLER_CANCELED_DEAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>卖家取消交易</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.WAITING_FOR_TRANSFER:
      text = (
        <div>
          <div className={styles.boardBgTitle}>请等待买家转账</div>
          <div className={styles.boardBgDesc}>
            买家
            <span className={styles.boardBgDescHighlight}>
              {isProfession ? orderDurations.ProfessionBuyerPaysOvertimeDelayTime:orderDurations.buyerPaysOvertimeDelayTime}
            </span>
            未转账
            <br />
            系统默认买家取消交易
          </div>
        </div>
      );
      break;
    case OrderStatus.BUYRER_CANCELD_DEAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>买家取消交易</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.TIME_OVER:
      text = (
        <div>
          <div className={styles.boardBgTitle}>超时取消交易</div>
          <div className={styles.boardBgDesc}>
            未操作超时取消，如有异议
            <br />
            请在<span className={styles.boardBgDescHighlight}><span className={styles.spanColor}>{orderDurations.waitingSellerConfirmDelayTime /* 30分钟 */}</span></span>
            内提交申请客
            <br />
            服介入，否则交易将自动结束
            <br />
            ，买家无法收到转币
          </div>
        </div>
      );
      break;
    case OrderStatus.TRANSFERRED:
      text = (
        <div>
          <div className={styles.boardBgTitle}>买家已转账</div>
          <div className={styles.boardBgDesc}>
            卖家确认付款后系统将
            <br />
            自动将币转入买家的账户
          </div>
        </div>
      );
      break;
    case OrderStatus.SELLER_DID_NOT_RECEIVE:
      text = (
        <div>
          <div className={styles.boardBgTitle}>卖家未收到款</div>
          <div className={styles.boardBgDesc}>
            卖家已提交,未收到付款 如有异议
            <br />
            请在<span className={styles.boardBgDescHighlight}><span className={styles.spanColor}>{orderDurations.waitingSellerConfirmDelayTime /* 30分钟 */}</span></span>内
            提交申请客服介
            <br />
            入，否则交易将自动结束，买家
            <br />
            无法收到转币
          </div>
        </div>
      );
      break;
    case OrderStatus.DISPUTING:
      text = (
        <div>
          <div className={styles.boardBgTitle}>争议订单</div>
          <div className={styles.boardBgDesc}>
            争议订单将由官方客服
            <br />
            介入协助处理
          </div>
        </div>
      );
      break;
    case OrderStatus.CANCELED_BY_OFFICIAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>平台取消交易</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.CONFIRMED_BY_OFFICIAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>平台交易完成！</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.DEAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>交易完成！</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.BUYER_NOT_APPEALS:
      text = (
        <div>
          <div className={styles.boardBgTitle}>卖家未收到款</div>
          <div className={styles.boardBgDesc}>
            超时未提交异议
            <br />
            系统自动结束交易
          </div>
        </div>
      );
      break;
    default:
      text = <div>状态错误:{state}</div>;
  }
  return (
    <TradeBoard
      className={styles.board}
      contentClassName={styles.boardContent}
      backgroundClassName={cn("buy-trade-board-bg", state)}
      background={
        <>
          <div className={styles.content}>
            <div className={cn("buy-trade-board-status", state)}></div>
            {text}
          </div>
        </>
      }
    >
      {children}
    </TradeBoard>
  );
};

const Risk = () => {
  return (
    <div className={styles.riskNotice}>
      <div className={styles.riskNoticeTitle}>VipPay风控</div>
      <div>
        1、为了降低您的交易风险，认证用户已向平台缴纳保证金，请放心 交易。
      </div>
      <div>
        2、平台认证用户，由平台担保交易资金安全性，如出现资金问题由
        平台方全额赔付。
      </div>
    </div>
  );
};

const TradingNotice = (props:any) => {
  
  return (
    props.isProfession? <div className={styles.tradingNotice}>
        <h4 style={{color: "#111",fontWeight:'600'}}>重要提醒：</h4>
        <p>1.超级商家挂单买家付款后不会提供付款凭证截图，需要通过您的收款账户自行核对是否到账；</p>
        <p>2.超级商家交易需要更加及时处理，若不及时处理可能造成您的资金损失或平台处罚；</p>
        <p>3.超级商家资金安全，交易风控需要自行承担，开始超级挂单时即表示您同意平台的免责协议。</p>
    </div>:
    <div className={styles.tradingNotice}>
      <div>
        1.请认真核实对方付款信息，如 到款信息与买方付款信息不一致 或 未收到转账
        千万不要放行您的数字货币，一旦确认我已收到款后转币给您造成的损失平台概不负责；
      </div>
      <div>2.收到买方真实付款后点击 确认转币</div>
    </div>
  );
};

const GuaranteeBuyer = () => {
  return (
    <Block topline title="买方付款信息">
      <div className={styles.systemBuyerCertification}>
        <div className={styles.systemBuyerInfo}>
          <Avatar className={styles.systemBuyerAvatar} src="" alt="买方头像" />
          <div className={styles.systemBuyerTag}>
            <Icon name="checked" size={"20px"} />
            <span className={styles.systemBuyerTagValue}>已缴纳保证金</span>
          </div>
          <div className={styles.systemBuyerTag}>
            <Icon name="checked" size={"20px"} />
            <span className={styles.systemBuyerTagValue}>平台认证用户</span>
          </div>
        </div>
        <div className={styles.systemBuyerDesc}>
          该用户为平台认证用户，付款信息暂不展示，请卖家查询到款后放心确认转移
        </div>
      </div>
    </Block>
  );
};

const ConfirmCompleteTradingDialogContent = ({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const placeZero = (n: number): string => String(n < 10 ? `0${n}` : n);
  const [countdown, { seconds }] = useCountDown({
    leftTime: 5000,
  });

  return MakeDialog({
    title: "重要提醒",
    confirmText: countdown !== 0 ? `${placeZero(seconds)}s` : "是",
    cancelText: "否",
    disabledConfirmButton: countdown !== 0,
    content: (
      <>
        请仔细核对您的收款账户
        <span style={{ color: "#FB2222", fontWeight: "bold" }}>
          「是否收到款」
        </span>
        ，
        <span style={{ color: "#FB2222", fontWeight: "bold" }}>
          「收款金额」
        </span>
        是否与您的卖币金额一致
      </>
    ),
    onConfirm,
    onCancel,
  });
};
